import { lazy } from 'react';
import NoBoundLayout from 'Layouts/NoBound/NoBound';

import { isAuthenticatedUser } from './helpers/authWrapper';

const OnBoarding = lazy(() => import('Containers/OnBoarding/OnBoarding'));

const routes = [
  {
    path: '/on-boarding',
    exact: true,
    ContentComponent: isAuthenticatedUser(OnBoarding),
    Layout: NoBoundLayout,
    bodyClass: ''
  }
];

export default routes;
